import React, { useState } from "react";

const ImagePopupViewer = ({ src, alt = "Image", fallbackSrc }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [imgSrc, setImgSrc] = useState(src);
  const [isFallback, setIsFallback] = useState(false);

  const handleImageError = () => {
    if (fallbackSrc) {
      setImgSrc(fallbackSrc);
      setIsFallback(true);
    }
  };

  return (
    <>
      <div
        className="bg-white shadow rounded-[12px] relative cursor-pointer p-1" 
        onClick={() => setIsOpen(true)}
      >
        <div className="bg-[#F5F6FB] rounded-[12px] overflow-hidden h-[180px] flex items-center justify-center">
          <img
            src={imgSrc}
            alt={alt}
            onError={handleImageError}
            className={
              isFallback
                ? "object-contain max-w-[60%] max-h-[60%]"
                : "object-contain max-w-full max-h-full"
            }
          />
        </div>
      </div>

      {isOpen && (
        <div
          className="fixed inset-0 z-[1050] bg-black/50 flex items-center justify-center"
          onClick={() => setIsOpen(false)}
        >
          <div
            className="bg-white p-4 rounded-lg max-w-[95vw] max-h-[90vh]"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={imgSrc}
              alt={alt}
              onError={handleImageError}
              className={
                isFallback
                  ? "object-contain max-w-[60vw] max-h-[60vh]"
                  : "object-contain max-w-[90vw] max-h-[80vh]"
              }
            />
          </div>
        </div>
      )}
    </>
  );
};

export default ImagePopupViewer;
